import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CompaniesComponent } from './companies/companies.component';
import { CompanyDetailsComponent } from './company-details/company-details.component';
import { SharedModule } from '../shared/shared.module';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgxPaginationModule } from 'ngx-pagination';
import { CompaniesRoutingModule } from './companies-routing.module';
import { EmailCompaniesComponent } from './email-companies/email-companies.component';
import { FeedbackCompaniesComponent } from './feedback-companies/feedback-companies.component';
import { EscapeHtmlPipe } from '../shared/pipes/keep-html.pipe';
import { CompaniesRfidBulkuploadComponent } from './companies-rfid-bulkupload/companies-rfid-bulkupload.component';
import { CompaniesRfidBulkuploadPreviewComponent } from './companies-rfid-bulkupload-preview/companies-rfid-bulkupload-preview.component';



@NgModule({
  declarations: [
    CompaniesComponent,
    CompanyDetailsComponent,
    EmailCompaniesComponent,
    FeedbackCompaniesComponent,
    EscapeHtmlPipe,
    CompaniesRfidBulkuploadComponent,
    CompaniesRfidBulkuploadPreviewComponent

  ],
  imports: [
    CommonModule,
    SharedModule,
    CompaniesRoutingModule,
    NgbModule,
    FormsModule,
    NgxPaginationModule,
    ReactiveFormsModule,
  ],
})
export class CompaniesCLAModule {}
